<template>
  <the-modal
    :visible="visible"
    :small="true"
    class="MenuModal"
    title="Menu"
    @close="$emit('close')"
  >
    <header class="MenuModal-Header">
      Toque na opção desejada para saber mais.
    </header>

    <nav class="MenuModal-MenuWrapper">
      <menu-list
        :items="menuItems"
        color-scheme="dark"
        @link-opened="linkOpened"
      />
    </nav>
  </the-modal>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .MenuModal {
    padding: 0;

    &-Profile {
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      background-color: $color-secondary-background-light;
    }

    &-Header {
      background-size: cover;
      background: url("/img/background-tutelary-council.jpg");
      padding: 50px 10px;
      font-size: 24px;
      color: $color-primary-foreground;
      text-align: center;
    }

    &-ProfileWrapper {
      display: flex;
      margin-left: auto;
      padding-right: 10px;

      flex-direction: column;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: center;
    }

    &-ProfileName {
      flex: 0 0 auto;
      font-size: 14px;
      font-weight: bold;
    }

    &-ProfileActionsList {
      flex: 0 0 auto;
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: flex;
    }

    &-ProfileActionsItem {
      font-size: 12px;
      flex: 0 1 auto;
    }

    &-ProfileActionsItem + &-ProfileActionsItem:before {
      padding: 0 5px;
      color: $color-primary-border;
      content: "|";
    }

    &-MenuWrapper {
      font-size: 18pt;
      margin: 25px 10px 75px;
      line-height: 40px;
    }
  }
</style>

<script>
  import { MENU_ALL } from "@/common/menus";
  import MenuList from "@/components/menu/MenuList";
  import TheModal from "@/components/modals/TheModal";

  export default {
    components: {
      MenuList,
      TheModal,
    },

    props: {
      visible: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        menuItems: MENU_ALL,
      };
    },

    methods: {
      linkOpened() {
        this.$emit("close");
      },
    },
  };
</script>
